import { DevtoolsAllowedEmails } from '@chiroup/core/types/Devtools.type';
import { useMemo } from 'react';
import { menuItems } from '../../data/menuItems';
import SidenavMenuItem from './SidenavMenuItem';

const researchers = ['clickdoc@yahoo.com', 'drbrown@brown-chiro.com', 'mbracciodc@gmail.com'];

const flagsAccess = [
  'kara@chiroup.com',
  'tim@chiroup.com',
  'brandon@chiroup.com',
  'jeremy@chiroup.com',
  'steve@chiroup.com',
  'todd@chiroup.com',
  'emily@chiroup.com',
  'k.tegtmeier@chiroup.com',
  'r.nabbe@chiroup.com',
  'm.gerton@chiroup.com',
  'b.mckeever@chiroup.com',
];

type Props = {
  user: any;
};

const SidenavMenu: React.FC<Props> = ({ user }) => {
  const currentPath = window.location.pathname;
  const email = user?.signInDetails?.loginId?.toLowerCase() || user?.email?.toLowerCase();

  const menuItemsFiltered = useMemo(() => {
    const isResearcher = researchers.includes(email);

    if (isResearcher) {
      return menuItems.filter(item => {
        if (
          item.path === 'research' ||
          item.path === 'clinical-skills' ||
          item.path === 'dashboard'
        ) {
          return true;
        }

        return false;
      });
    }

    const hasFlagsAccess = flagsAccess.includes(email);
    const hasDevtoolsAccess = DevtoolsAllowedEmails[email as keyof typeof DevtoolsAllowedEmails];

    return menuItems.filter(item => {
      if (item.path === 'flags' && !hasFlagsAccess) {
        return false;
      }

      if (item.path === 'developer-tools' && !hasDevtoolsAccess) {
        return false;
      }

      return true;
    });
  }, [email]);

  return (
    <div className="space-y-1">
      {menuItemsFiltered?.map(menuItem => (
        <SidenavMenuItem
          key={menuItem.path}
          currentPath={currentPath}
          path={menuItem.path}
          icon={menuItem.icon}
          title={menuItem.title}
          menuItems={menuItem.menuItems}
          external={menuItem.external}
        />
      ))}
      {/* <div className="pt-8">
        <h3
          className="px-3 text-xs font-semibold text-gray-500 uppercase tracking-wider"
          id="teams-headline"
        >
          Shortcuts
        </h3>
        <div
          className="mt-1 space-y-1"
          role="group"
          aria-labelledby="teams-headline"
        >
          <a
            href="https://chiroup.com/blog/"
            target="_blank"
            rel="noreferrer"
            className="group flex items-center px-3 py-2 text-base leading-5 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:bg-gray-50"
          >
            <span
              className="w-2.5 h-2.5 mr-4 bg-yellow-500 rounded-full"
              aria-hidden="true"
            />
            <span className="truncate">ChiroUp Blog</span>
          </a>
        </div>
      </div> */}
    </div>
  );
};

export default SidenavMenu;
